import { FeatureCollection } from '@turf/turf';
import * as Turf from '@turf/turf';
import { LngLatBounds } from 'maplibre-gl';
import {
  clearHighlight as clearFeatureHighlight,
  highlightFeatureCollection as highlightSimpleFeatureCollection,
} from '~/components/Map/panels/GeocollectDatatablePanel/utils/MapHighlightUtils';

const MapUtils = {
  clearHighlight: () => {
    clearFeatureHighlight();
  },
  zoomToFeatureCollection: async (featureCollection: FeatureCollection) => {
    const map = window.map;
    if (!map) {
      return;
    }

    const bbox = Turf.bbox(featureCollection);
    map.fitBounds(bbox as any, {
      duration: 500,
      padding: 50,
    });

    // Đợi 500ms
    await new Promise((resolve) => setTimeout(resolve, 500));
  },
  highlightFeatureCollection: async (
    featureCollection: FeatureCollection,
    _elementStyle?: { size?: number; frame?: string; strokeWidth?: number; opacity?: number },
  ) => {
    highlightSimpleFeatureCollection(featureCollection);
  },
  /**
   * Trigger a resize event to update the map
   */
  triggerResizeEvent: () => {
    const map = window.map;
    const beforeMap = window.beforeMap;
    if (map) {
      map.resize();
    }
    if (beforeMap) {
      beforeMap.resize();
    }

    // Trigger window resize event for other components
    const resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);

    // Call resize on next frame after DOM reflow
    requestAnimationFrame(() => {
      if (window.map) {
        window.map.resize();
      }
      if (window.beforeMap) {
        window.beforeMap.resize();
      }
    });

    // Secondary timeout to catch slower animations or heavy component unmounting
    setTimeout(() => {
      if (window.map) {
        window.map.resize();
      }
      if (window.beforeMap) {
        window.beforeMap.resize();
      }
      window.dispatchEvent(new Event('resize'));
    }, 150);
  },

  /**
   * Zoom to default view - Thu phóng mặc định
   * hiện tại sẽ zoom tới bounds, nếu không có thì zoom tới Việt Nam
   * @param bounds: Nên truyền vào project bounds
   */
  zoomToDefaultView: (bounds?: LngLatBounds) => {
    const map = window.map;
    if (!map) {
      return;
    }
    const VietnamBounds = new LngLatBounds([
      [100.63813521986384, 8.180044265401762],
      [111.92864096015262, 23.492204558438758],
    ]);

    if (bounds) {
      map.fitBounds(bounds);
    } else {
      map.fitBounds(VietnamBounds);
    }
  },

  zoomIn: () => {
    const map = window.map;
    if (!map) {
      return;
    }
    map.zoomIn();
  },

  zoomOut: () => {
    const map = window.map;
    if (!map) {
      return;
    }
    map.zoomOut();
  },
};

export default MapUtils;
